import { getUserList } from '@repo/api';
import { queryKeys } from '@repo/lib';
import { useQuery } from '@tanstack/react-query';

export const useUserListQuery = (query: string) => {
  const { data, isLoading, error } = useQuery({
    enabled: query.length >= 2,
    queryFn: () => getUserList(query),
    queryKey: queryKeys.users.list(query),
  });

  return {
    error,
    isLoading,
    users: data || [],
  };
};
